'use client';

import { CMSSection } from '../CmsSection';
import { renderCollectionItem, type ContentGroupItem } from '../DoubleCard';

import styles from './DoubleCardWide.module.scss';

export interface DoubleCardWideProps {
  /** Collection of content items to render */
  itemsCollection?: {
    items: Array<ContentGroupItem | null>;
  } | null;
  className?: string;
  /** Extra CMS data keyed by entry ID */
  extraDataRecord?: Record<string, unknown>;
}

/**
 * DoubleCardWide - Wide variant of DoubleCard layout
 *
 * Displays up to 2 content items side-by-side with wider card styling.
 * Reuses the polymorphic renderCollectionItem from DoubleCard.
 */
export function DoubleCardWide({
  className,
  extraDataRecord,
  itemsCollection,
}: DoubleCardWideProps) {
  const items =
    itemsCollection?.items.filter((item): item is ContentGroupItem => item !== null) ?? [];

  if (items.length === 0) {
    return null;
  }

  return (
    <CMSSection className={className} data-testid="DoubleCardWide-section">
      <div className={styles.container}>
        <div className={styles.wrapper}>
          {items.map((item) => {
            const renderedItem = renderCollectionItem(item, extraDataRecord);

            if (!renderedItem) return null;

            return (
              <div key={item.sys.id} className={styles.col}>
                {renderedItem}
              </div>
            );
          })}
        </div>
      </div>
    </CMSSection>
  );
}

DoubleCardWide.displayName = 'DoubleCardWide';
